import { EgretLoadable } from "egret";
import ConstantList from "../../appConfig";

const PatientIndex = EgretLoadable({
  loader: () => import("./PatientIndex"),
});

const PatientManagerIndex = EgretLoadable({
  loader: () => import("./PatientManagerIndex"),
});

const PatientCreate = EgretLoadable({
  loader: () => import("./PatientCreate/PatientCreate"),
});

const PatientCreateEdit = EgretLoadable({
  loader: () => import("./PatientCreateEdit"),
});

const PatientDetail = EgretLoadable({
  loader: () => import("./PatientDetail"),
});

const PatientTransferIn = EgretLoadable({
  loader: () => import("../PatientTransferIn/Index"),
});

const PatientTransferOut = EgretLoadable({
  loader: () => import("../PatientTransferOut/Index"),
});
const PatientManagementUnit = EgretLoadable({
  loader: () => import("../PatientManagementUnit/Index"),
});
const InterestIndex = EgretLoadable({
  loader: () => import("./InterestIndex/InterestIndex"),
});
const PatientAdministrativeUnit = EgretLoadable({
  loader: () => import("../PatientAdministrativeUnit/Index"),
});
const PatientOverview = EgretLoadable({
  loader: () => import("./Component/PatientOverview/PatientOverview"),
});

const Routes = [
  {
    path: ConstantList.ROOT_PATH + "patient/list",
    exact: true,
    component: PatientIndex,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/DOT",
    exact: true,
    component: PatientIndex,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/list/:id",
    exact: true,
    component: PatientIndex,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/list/:id/:transfer",
    exact: true,
    component: PatientIndex,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/edit/:id",
    exact: true,
    component: PatientCreateEdit,
    settings: { layout1Settings: { leftSidebar: { mode: "close" } } }
  },
  {
    path: ConstantList.ROOT_PATH + "patient/edit/:id/:encounterId",
    exact: true,
    component: PatientCreateEdit,
    settings: { layout1Settings: { leftSidebar: { mode: "close" } } }
  },
  {
    path: ConstantList.ROOT_PATH + "patient/create",
    exact: true,
    component: PatientCreate,
    settings: { layout1Settings: { leftSidebar: { mode: "close" } } }
  },
  {
    path: ConstantList.ROOT_PATH + "patient/detail/:id",
    exact: true,
    component: PatientDetail,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/management-unit",
    exact: true,
    component: PatientManagementUnit,
    auth: [
      "ROLE_ADMIN", 
      "ROLE_ORGANIZATION",
      "ROLE_DEPARTMENT",
    ],
  },
  {
    path: ConstantList.ROOT_PATH + "patient/management-unit/:status",
    exact: true,
    component: PatientManagementUnit,
    auth: [
      "ROLE_ADMIN", 
      "ROLE_ORGANIZATION",
      "ROLE_DEPARTMENT",
    ],
  },
  {
    path: ConstantList.ROOT_PATH + "patient/transfer-in",
    exact: true,
    component: PatientTransferIn,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/transfer-in/:status",
    exact: true,
    component: PatientTransferIn,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/transfer-out",
    exact: true,
    component: PatientTransferOut,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/transfer-out/:status",
    exact: true,
    component: PatientTransferOut,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/interest/:source",
    exact: true,
    component: InterestIndex,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/administrative-unit/:level/:id",
    exact: true,
    component: PatientAdministrativeUnit,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/org/:id",
    exact: true,
    component: PatientAdministrativeUnit,
  },
  {
    path: ConstantList.ROOT_PATH + "patient/overview/:id",
    exact: true,
    component: PatientOverview,
    settings: { 
      layout1Settings: { 
        leftSidebar: { 
          show: false,
          mode: "close"
        },
        topbar: { 
          show: false
        }
      } 
    }
  },
  {
    path: ConstantList.ROOT_PATH + "patient/management",
    exact: true,
    component: PatientManagerIndex
  },
];

export default Routes;
